import { render, staticRenderFns } from "./TilesView.vue?vue&type=template&id=064644a4"
import script from "./TilesView.vue?vue&type=script&lang=js"
export * from "./TilesView.vue?vue&type=script&lang=js"
import style0 from "./TilesView.vue?vue&type=style&index=0&id=064644a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports